import FormGroup from './FormGroup.view';

export default FormGroup;
